import Welcome from "./components/Welcome";
import Features from "./components/Features";
import Others from "./components/Others";
import GetInTouch from "../home/components/GetInTouch";
import SEO from "../../components/common/SEO";
    
const index = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Youstad Ledger",
    "description": "Professional invoice generator and cash register system for academies. Streamline billing and financial management.",
    "url": "https://youstad.com/ledger",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "featureList": [
      "Invoice Generation",
      "Cash Register Management",
      "Financial Tracking",
      "Billing Automation"
    ]
  };

  return (
    <>
      <SEO
        title="Youstad Ledger - Invoice Generator & Cash Register | Academy Financial Management"
        description="Professional invoice generator and cash register system for academies. Streamline billing, automate invoicing, and manage financial operations with Youstad Ledger."
        keywords="invoice generator, cash register, academy billing, financial management, invoice automation, billing system, academy finance"
        url="https://youstad.com/ledger"
        structuredData={structuredData}
      />
      <Welcome />
      <Features />
      <Others />
      <GetInTouch />
    </>
  );
};

export default index;